import { Box, Typography } from "@mui/material";
import { LooksOne } from "@mui/icons-material";
import { Avatar } from "../../../../components/fieldsViews/fields/Avatar";
import { getShortName } from "../../../../utils/parseCalendarEvents";
import { getChipLabel } from "../../../../components/chips/CustomChip";
import { ColoredLabelChip } from "../../../../components/chips/ColoredLabelChip";
import { getSessionStatusColor, useSessionStatusField } from "./useSessionStatus";
import { NeuroAssignTechsRowProps, PrioritySession } from "./types.nfbAssign";

const getClientName = (session: PrioritySession) => {
    const client = session.treatment?.client?.user_id;
    if (client) {
        const clientName = getShortName(client.first_name, client.last_name);
        return clientName ?? "Sem nome";
    }
    const leadName = getShortName(session.lead?.first_name, session.lead?.last_name);
    return leadName ?? "Sem nome";
};

export const NeuroAssignTechsRow = ({ session, order, onClick }: NeuroAssignTechsRowProps) => {
    const statusField = useSessionStatusField();
    const accentColor = getSessionStatusColor(statusField, session.status);
    const statusLabel = statusField ? getChipLabel(statusField, session.status) : undefined;

    const clientName = getClientName(session);
    const serviceName = session.service?.name;
    const technicianAvatar = session.technician?.user_id?.avatar;
    const hasTechnician = !!session.technician?.user_id;

    return (
        <Box
            onClick={onClick}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.2,
                backgroundColor: "white",
                border: "1px solid #e0e0e0",
                borderLeft: `3px solid ${accentColor}`,
                borderRadius: "10px",
                p: 1,
                cursor: "pointer",
                "&:hover": { borderColor: "#44749a", borderLeftColor: accentColor },
            }}
        >
            <Box
                sx={{
                    width: 20,
                    height: 20,
                    borderRadius: "6px",
                    flex: "none",
                    backgroundColor: "#e5edf3",
                    color: "#2d5a7b",
                    fontSize: 12,
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {order}
            </Box>

            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography variant="body2" fontWeight={600} noWrap>
                    {clientName}
                </Typography>
                {serviceName ? (
                    <Typography variant="caption" component="div" noWrap sx={{ color: "#9e9e9e" }}>
                        {serviceName}
                    </Typography>
                ) : null}
            </Box>

            {statusLabel ? (
                <Box sx={{ transform: "scale(0.8)", transformOrigin: "right" }}>
                    <ColoredLabelChip label={statusLabel} color={accentColor} />
                </Box>
            ) : null}

            {hasTechnician ? <Avatar value={technicianAvatar} styles={{ width: 26, height: 26 }} /> : null}

            {session.is_first_session ? (
                <LooksOne titleAccess="Primeira sessão" sx={{ width: 18, height: 18, color: "#2d5a7b", flex: "none" }} />
            ) : null}
        </Box>
    );
};
